import { Globe, Shield, Terminal } from 'lucide-react'
import type { FloatingIconItem } from '@/components/ui/floating-icons-hero-section'
import {
  IconBinance,
  IconCalendar,
  IconDiscord,
  IconFigma,
  IconGitHub,
  IconGoogle,
  IconGroww,
  IconLinear,
  IconMicrosoft,
  IconSlack,
  IconStripe,
} from './connect-platform-brand-icons'

/** baby: Brand-colored tiles for /nin and /ninxl: square pixel borders + stronger tints */
export const EIGHTBIT_CONNECT_PLATFORM_ICONS: FloatingIconItem[] = [
  {
    id: 1,
    icon: IconGoogle,
    className: 'top-[8%] left-[8%]',
    tileBackgroundColor: '#4285F440',
    tileBorderColor: '#4285F4',
  },
  {
    id: 2,
    icon: IconSlack,
    className: 'top-[18%] right-[6%]',
    tileBackgroundColor: '#36C5F040',
    tileBorderColor: '#36C5F0',
  },
  {
    id: 3,
    icon: IconGitHub,
    className: 'top-[78%] left-[8%]',
    iconColor: '#181717',
    tileBackgroundColor: '#18171730',
    tileBorderColor: '#181717',
  },
  {
    id: 4,
    icon: IconFigma,
    className: 'bottom-[8%] right-[8%]',
    tileBackgroundColor: '#A259FF40',
    tileBorderColor: '#A259FF',
  },
  {
    id: 5,
    icon: Terminal,
    className: 'top-[4%] left-[28%]',
    iconColor: '#334155',
    tileBackgroundColor: '#33415535',
    tileBorderColor: '#334155',
  },
  {
    id: 6,
    icon: Globe,
    className: 'top-[6%] right-[28%]',
    iconColor: '#0284C7',
    tileBackgroundColor: '#0284C740',
    tileBorderColor: '#0284C7',
  },
  {
    id: 7,
    icon: IconMicrosoft,
    className: 'bottom-[10%] left-[22%]',
    tileBackgroundColor: '#00A4EF40',
    tileBorderColor: '#0078D4',
  },
  {
    id: 8,
    icon: IconDiscord,
    className: 'top-[42%] left-[4%]',
    tileBackgroundColor: '#5865F240',
    tileBorderColor: '#5865F2',
  },
  {
    id: 9,
    icon: IconCalendar,
    className: 'top-[72%] right-[22%]',
    tileBackgroundColor: '#4285F440',
    tileBorderColor: '#3367D6',
  },
  {
    id: 10,
    icon: IconStripe,
    className: 'top-[88%] left-[62%]',
    tileBackgroundColor: '#635BFF40',
    tileBorderColor: '#635BFF',
  },
  {
    id: 11,
    icon: IconGroww,
    className: 'top-[48%] right-[4%]',
    tileBackgroundColor: '#387ED140',
    tileBorderColor: '#387ED1',
  },
  {
    id: 12,
    icon: IconBinance,
    className: 'top-[58%] left-[28%]',
    tileBackgroundColor: '#F0B90B45',
    tileBorderColor: '#F0B90B',
  },
  {
    id: 13,
    icon: Shield,
    className: 'top-[4%] left-[52%]',
    iconColor: '#10B981',
    tileBackgroundColor: '#10B98140',
    tileBorderColor: '#10B981',
  },
  {
    id: 14,
    icon: IconLinear,
    className: 'bottom-[6%] right-[42%]',
    tileBackgroundColor: '#5E5CE640',
    tileBorderColor: '#5E5CE6',
  },
]
